import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Navbar from '../../components/Navbar/Navbar';
import Attorney from '../../components/attorneys';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
//import Newsletter from '../../components/Newsletter/Newsletter';

const AttorneyPage = () => {
	return (
		<Fragment>
			<Navbar />
			<PageTitle pageTitle={"L'équipe"} pagesub={'Equipe'} />
			<Attorney />
			<Footer />
			<Scrollbar />
		</Fragment>
	);
};
export default AttorneyPage;
